import { Theme } from '@mui/material/styles';

export const largeButton = (theme: Theme) => ({
    fontSize: '1.15rem',
    padding: theme.spacing(1, 3),
});
